var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar-component",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.placeholder))]),_c('ym-icon',{staticClass:"icon-search",attrs:{"name":"search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }